import { TaskData } from '@api/generator';

const statuses = ['complete', 'completed', 'incomplete'];

export function filterTask(type: string, data: TaskData[]): TaskData[] {
  let filterData: TaskData[] | null = [];
  switch (type) {
    case 'task':
      filterData = data.filter((item) =>
        !statuses.includes(item.status?.toLowerCase()) ? item : null,
      );
      break;
    case 'history':
      filterData = data.filter((item) =>
        statuses.includes(item.status?.toLowerCase()) ? item : null,
      );
      break;
  }
  return filterData;
}
